import { combineReducers } from 'redux'
import $$byId from 'components/members/reducers/byId'
import $$allIds from 'components/members/reducers/allIds'

export default combineReducers({
  $$byId,
  $$allIds,
})
